module.exports = __webpack_public_path__ + "img/Steve.6385ff26.png";